<template>
  <div class="columns">
    <div class="column is-three-fifths-desktop formBlock">
      <div class="containerr">
          <h4 class="has-text-weight-bold">We'd love to hear from you!</h4>
          <form novalidate>
              <flash-message :addBottomMargin="true"></flash-message>

              <div class="field radioSec">
                  <div class="control">
                      <label class="radio">
                          <input type="radio" name="userType" :disabled="sending" v-model="form.user_type" value="reviewer">
                          <span class="is-size-7">I am a reviewer</span>
                      </label>
                      <label class="radio">
                          <input type="radio" name="userType" :disabled="sending" v-model="form.user_type" value="business">
                          <span class="is-size-7">I am a business</span>
                      </label>
                  </div>
              </div>

              <p class="control">
                  <input :disabled="sending" class="input" type="text" placeholder="First name" v-model.trim="form.first_name" />
              </p>
              <p v-if="form.errors.has('first_name')" class="help is-danger" v-html="form.errors.get('first_name')"></p>

              <p class="control">
                  <input :disabled="sending" class="input" type="text" placeholder="Last name" v-model.trim="form.last_name" />
              </p>
              <p v-if="form.errors.has('last_name')" class="help is-danger" v-html="form.errors.get('last_name')"></p>

              <p class="control">
                  <input :disabled="sending" class="input" type="email" placeholder="Email address" v-model.trim="form.email" />
              </p>
              <p v-if="form.errors.has('email')" class="help is-danger" v-html="form.errors.get('email')"></p>

              <p class="control">
                  <input :disabled="sending" class="input" type="tel" placeholder="Mobile number" v-model.trim="form.mobile" />
              </p>
              <p v-if="form.errors.has('mobile')" class="help is-danger" v-html="form.errors.get('mobile')"></p>

              <p class="control">
                  <textarea :disabled="sending" v-model.trim="form.message" class="textarea has-fixed-size" placeholder="Message"></textarea>
              </p>
              <p v-if="form.errors.has('message')" class="help is-danger" v-html="form.errors.get('message')"></p>

              <p class="control is-clearfix">
                  <button :disabled="!canSubmit" @click.prevent="submitRegister" type="submit" :class="['is-fullwidth button', { 'is-loading': sending }]">SUBMIT</button>
              </p>

              <!-- reCAPTCHA -->
              <div class="columns">
                  <div class="column is-marginless">
                      <div class="has-text-right-desktop has-text-right-tablet">
                          <vue-recaptcha
                                  ref="recaptcha"
                                  @verify="onCaptchaVerified"
                                  @expired="onCaptchaExpired"
                                  size="invisible"
                                  :sitekey="`${google_recaptcha_site_key}`">
                          </vue-recaptcha>
                      </div>
                  </div>
              </div>
          </form>
      </div>
    </div>
    <div class="column faqBlock">
        <div class="columns">
            <div class="column">
                <h4 class="has-text-weight-bold">FAQs for business:</h4>
                <div class="content">
                    <a :href="`${blog_url}/faqs/your-business-profile`">
                        <span>Why is my business on Hellopeter if I haven’t signed up?</span>
                    </a>
                    <a :href="`${blog_url}/faqs/your-business-profile`">
                        <span>How do I claim my business on Hellopeter?</span>
                    </a>
                    <a :href="`${blog_url}/faqs/hellopeter-packages`">
                        <span>How do I know which package is right for my business?</span>
                    </a>
                    <a :href="`${blog_url}/faqs/hellopeter-packages`">
                        <span>Do I have to pay to list my business on Hellopeter?</span>
                    </a>
                </div>
            </div>
            <div class="column">
                <h4 class="has-text-weight-bold">FAQs about reviews:</h4>
                <div class="content">
                    <a :href="`${blog_url}/faqs/reviews`">
                        <span>Can businesses remove reviews?</span>
                    </a>
                    <a :href="`${blog_url}/faqs/reviews`">
                        <span>Does Hellopeter decide which reviews are posted and which are not?</span>
                    </a>
                    <a :href="`${blog_url}/faqs/reviews`">
                        <span>Do businesses have to pay to reply to reviews?</span>
                    </a>
                </div>
            </div>
            <div class="column">
                <h4 class="has-text-weight-bold">About Hellopeter:</h4>
                <div class="content">
                    <a :href="`${blog_url}/faqs/how-does-hellopeter-work`">
                        <span>What is Hellopeter?</span>
                    </a>
                    <a :href="`${blog_url}/faqs/how-does-hellopeter-work`">
                        <span>What is Hellopeter’s role in dispute resolution?</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  import ApiResource from '@/api/ApiResource'
  import FlashMessage from '@/components/FlashMessage'
  import VueRecaptcha from 'vue-recaptcha'

  export default {
    name: 'Contact',
    data(){
      return {
        form: new ApiResource({
          user_type: '',
          first_name: '',
          last_name: '',
          email: '',
          mobile: '',
          message: '',
          recaptchaToken: ''
        }),
        google_recaptcha_site_key: process.env.GOOGLE_RECAPCHA_SITE_KEY,
        blog_url: process.env.BLOG_URL,
        sending: false
      }
    },
    components: {
      FlashMessage,
      VueRecaptcha
    },
    mounted () {
      if (window.innerWidth > 1023) {
        const headerWidth = document.getElementById('default-header').getBoundingClientRect().width
        const usedWidth = document.querySelector('#default-header .navbar').getBoundingClientRect().width
        const leftSpace = (headerWidth - usedWidth)/2
        document.querySelector('.formBlock .containerr').style.marginLeft = `${leftSpace}px`
      }
    },
    computed: {
      canSubmit () {
        return this.form.user_type &&
          this.form.first_name &&
          this.form.last_name &&
          this.form.email &&
          this.form.mobile &&
          this.form.message
      }
    },
    methods: {
      submitRegister () {
        this.form.errors.clear(null)
        this.$refs.recaptcha.execute()
      },

      /**
       * Reset recaptcha when expired
       *
       * @returns {void}
       */
      onCaptchaExpired () {
        this.$refs.recaptcha.reset()
      },

      /**
       * Handle when recaptcha passes
       *
       * @returns {void}
       */
      onCaptchaVerified (recaptchaToken) {
        this.sending = true
        this.$refs.recaptcha.reset()
        this.form.recaptchaToken = recaptchaToken

        //const self = this
        this.form.send('/consumer/contact-us')
          .then(() => {
            this.sending = false
            flash('We have received your query. We will contact you soon.', 'is-success')
          })
          .catch(() => {
            this.sending = false
          })
      }
    }
  }
</script>

<style scoped>
  .columns.router-view {
      margin-bottom: 0;
      display: block;
  }

  .help {
      margin-top: -10px;
  }

  .formBlock {
      padding-bottom: 15px
  }

  .formBlock .containerr {
      max-width: 610px;
  }

  .formBlock h4 {
      color:#58595B;
      margin: 10px 0 15px;
      font-size: 1.5rem !important;
  }

  .formBlock .control {
      margin-bottom: 15px;
  }

  .formBlock .input, .formBlock .textarea {
      border-radius: 0!important;
      box-shadow: none!important;
      height: 2.5rem;
      font-size: 0.9rem;
      color: #58595B;
      padding-left: 1rem!important;
  }

  .formBlock .radio + .radio {
      margin-left: 25px;
  }

  .formBlock [type="radio"] {
      -webkit-appearance: none;
      -moz-appearance: none;
      width: 18px;
      height: 18px;
      border: 1px solid #dbdbdb;
      border-radius: 50%;
      vertical-align: top;
      padding: 3px;
      background-clip: content-box;
      margin-right: 5px;
  }

  .formBlock [type="radio"]:checked {
      background-color: #30AAE1;
      border: 1px solid #30AAE1;
  }

  .formBlock [type="radio"] + span {
      color: #58595B;
  }

  .formBlock .button {
      border: 0;
      border-radius: 0;
      background-color: #30AAE1;
      color: #ffffff;
      font-size: 0.85rem;
      height: 40px;
      padding: 0 4rem;
  }

  .formBlock .button:disabled {
      background: lightgray;
  }


  .faqBlock {
      background-color: #F5F5F5;
      padding-top: 10px;
      padding-bottom: 20px;

  }

  .faqBlock .column h4 {
      color:#58595B;
      font-size: 1rem;
      margin-top: 15px;
      margin-bottom: 15px;
  }

  .faqBlock .column:not(:first-of-type) h4 {
      margin-top: 0
  }

  .faqBlock .content {
      padding-left: 17px
  }

  .faqBlock .content:not(:last-child) {
      margin-bottom: 25px;
  }

  .faqBlock a {
      color: #30aae1;
      text-decoration: underline;
      font-size: 0.75rem;
      margin-bottom: 10px;
      display: list-item;
  }

  .faqBlock a span {
      margin-left: -8px;
      display: block;
  }

  .formBlock, .faqBlock {
      padding-left: 30px;
      padding-right: 30px;
  }

  @media screen and (min-width: 768px) {
      .formBlock {
          padding-bottom: 35px
      }

      .formBlock h4 {
          font-size: 2rem !important;
      }

      .formBlock button[type="submit"] {
          width: initial;
          float: right;
      }

      .faqBlock {
          padding-bottom: 55px;
      }

      .faqBlock .column h4, .faqBlock .column:not(:first-of-type) h4 {
          margin-top: 45px;
      }

      .faqBlock .content {
          padding-left: 16px
      }

      .faqBlock a span {
          margin-left: -7px;
      }
  }

  @media screen and (min-width: 1024px) {
      .columns.router-view {
          display: flex;
      }

      .formBlock h4 {
          margin-top: 30px;
      }

      .faqBlock {
          padding-left: 75px;
      }

      .faqBlock .columns {
          display: block;
      }

      .faqBlock .column h4 {
          margin-top: 50px;
      }

      .faqBlock .column:not(:first-of-type) h4 {
          margin-top: 20px;
      }

      .faqBlock a span {
          margin-left: -6px;
      }
  }

  @media screen and (max-width: 1023px) {
      .formBlock .containerr {
          max-width: 100%;
      }
  }
</style>


// WEBPACK FOOTER //
// src/pages/Contact.vue